import React from 'react';
import { LoginBaseProps } from 'containers/login-page/email/index';

export default function LoginComplete({ content }: LoginBaseProps): JSX.Element | null {
  return <p className="w-3/4 mt-36 mx-auto heading-l">{content.loginComplete}</p>;
}
